import AppRoutes from "./routes/index";
import ProvideAuth from "./context/Auth";
import Notification, { notify } from "react-notify-toast";
// import Notifications from "./templates/adminPortal/Socket";
import { useUserback } from "@userback/react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Gleap from "gleap";
import { fetchIPAddress } from "./redux/classes/ipAddressslice";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CustomUserbackProvider from "./common/CustomUserbackProvider";
import ScrollToTop from "./common/ScrollToTop";
import EnvironmentIndicator from "./common/EnvironmentIndicator";

const stripePromise = loadStripe(
  "pk_test_51QnIiwCM2kq63G3G043lAdhh8imre5jnUiTsQqQhIfhsUZU87gAYscKgZXiXnjIABRsXHR69otQp8l23IEtTD8ft00IzGHMaWl"
);

function App() {
  const dispatch = useDispatch();
  const [count, setCount] = useState(0);
  const { show, hide, open } = useUserback();

  useEffect(() => {
    // Gleap.initialize("EKa1LYppi62qK0R9TAC3nIRxMWgMzOSj");
    dispatch(fetchIPAddress());
    show()
  }, []);

  return (
    <div id="scroller" className="">
      {/* <Notifications/> */}
      {/* <CustomUserbackProvider> */}
        <Elements stripe={stripePromise} options={{ disableLink: true }}>
          <ProvideAuth>
            {/* <BrowserRouter> */}
            <Notification />
            <EnvironmentIndicator />
            <AppRoutes />
            {/* </BrowserRouter> */}
          </ProvideAuth>
        </Elements>
      {/* </CustomUserbackProvider> */}
    </div>
  );
}
export default App;
